import React, {Component} from "react";

import "./HallBasicInfoCard.component.scss";
import {connect} from "react-redux";
import {hallsStoreSelectors} from "../../../store/store";
import {HallBaseConfig, STARTING_PAGE} from "../../../reducers/hallsList.reducer";
import {formatDateText} from "../../../../../utils/utils";
import {checkPermission} from "../../../../../utils/Authorization/authorization";

export interface HallBasicInfoCardProps {
    inspectingHall: HallBaseConfig;
    inspectingHallLoading: boolean;
    inspectingHallServersLoading: boolean;
    inspectingHallServers: any;
    onOpenEditHall?: (...args: any[]) => any;
    onOpenDelHall?: (...args: any[]) => any;
}

export interface HallBasicInfoCardState {
    inspectingHallServersActive: number;
    inspectingHallServersOnline: number;
}

class HallBasicInfoCard extends Component<HallBasicInfoCardProps, HallBasicInfoCardState> {
    constructor(props) {
        super(props);
        this.state = {
            inspectingHallServersActive: 0,
            inspectingHallServersOnline: 0,
        };
    }

    componentDidUpdate() {
        if (this.props.inspectingHallServers && this.props.inspectingHallServers.length > 0) {
            if(this.props.inspectingHallServers.length !== this.state.inspectingHallServersActive) {
                this.setState({inspectingHallServersActive: this.props.inspectingHallServers.length})
            }
           const serversOnline = this.props.inspectingHallServers.filter(server => server.is_online)
            if(serversOnline.length !== this.state.inspectingHallServersOnline) {
                this.setState({inspectingHallServersOnline: serversOnline.length})
            }
        }

    }

    render() {
        return this.props.inspectingHallLoading ||
        !this.props.inspectingHall ? null : (
            <div id="HallBasicInfoCard">
                <div className="hall-card">
                    <div className="row">
                        <div className="col-12">
                            <div className="list-title-icon">
                                <div className="hall-card-title h1">
                                    Basic information
                                </div>
                                {checkPermission("edit_hall") && (
                                    <div
                                        className="btn_icon icon-edit push tooltip-icon"
                                        onClick={() =>
                                            this.props.onOpenEditHall()
                                        }
                                    >
                                        <span className="tooltip-text">Edit</span>
                                        <i className="icon-pencil-alt-light"></i>
                                    </div>
                                )}
                                {checkPermission("list_servers") &&
                                    checkPermission("delete_hall") &&
                                    !this.props.inspectingHallServersLoading &&
                                    this.state.inspectingHallServersActive == 0 && (
                                        <div
                                            style={{marginLeft: checkPermission("edit_hall") ? "0.5rem" : "auto"}}
                                            className="btn_icon icon-del push tooltip-icon"
                                            onClick={() =>
                                                this.props.onOpenDelHall(true)
                                            }
                                        >
                                            <span className="tooltip-text">Delete</span>
                                            <i className="icon-trash-alt-light"></i>
                                        </div>
                                    )}
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="hall-info-section">
                                <div className="hall-info-title h4">
                                    Hall name
                                </div>
                                <div className="hall-info-value">
                                    {this.props.inspectingHall.name}
                                </div>
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="hall-info-section">
                                <div className="hall-info-title h4">
                                    Subsidiary
                                </div>
                                <div className="hall-info-value">
                                    {
                                        this.props.inspectingHall.subsidiary
                                            .description
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="hall-info-section">
                                <div className="hall-info-title h4">
                                    Created on
                                </div>
                                <div className="hall-info-value">
                                    {formatDateText(
                                        this.props.inspectingHall.created_on, "short", true, true, true
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="hall-info-section">
                                <div className="hall-info-title h4">
                                    Timezone
                                </div>
                                <div className="hall-info-value">
                                    {this.props.inspectingHall.timezone ? this.props.inspectingHall.timezone.timezone : ``}
                                </div>
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="hall-info-section">
                                <div className="hall-info-title h4">
                                    Hall status
                                </div>
                                <div className="hall-info-value">
                                    {this.state.inspectingHallServersOnline ?
                                        (
                                            <div>
                                                <i className="icon-wifi-solid hall-info-icon green"/>{" "}
                                                Online
                                            </div>
                                        ) : (
                                            <div>
                                                <i className="icon-wifi-slash-light hall-info-icon"/>{" "}
                                                Offline
                                            </div>
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="hall-info-section">
                                <div className="hall-info-title h4">
                                    Location
                                </div>
                                <div className="hall-info-value">
                                    {this.props.inspectingHall.address_line_1},{" "}
                                    {this.props.inspectingHall.address_line_2}
                                </div>
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="hall-info-section">
                                <div className="hall-info-title h4">
                                    License Renew
                                </div>
                                <div className="hall-info-value">
                                    {this.props.inspectingHall
                                        .allow_license_renew == true
                                        ? "Available"
                                        : "Unavailable"}
                                </div>
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="hall-info-section">
                                <div className="hall-info-title h4">
                                    Renewal Days / Days Before Expiration
                                </div>
                                <div className="hall-info-value">
                                    {this.props.inspectingHall
                                        .allow_license_renew &&
                                    this.props.inspectingHall
                                        .renewal_trigger_days &&
                                    this.props.inspectingHall
                                        .renewal_trigger_days !== 0
                                        ? this.props.inspectingHall
                                            .renewal_trigger_days
                                        : "-"}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    inspectingHall: hallsStoreSelectors.inspectingHall(state),
    inspectingHallLoading: hallsStoreSelectors.inspectingHallLoading(state)
});

export default connect(mapStateToProps, null)(HallBasicInfoCard);
